import { Archive } from "lucide-react";
import type { CatalogItemCopy } from "@/lib/api/catalog";

interface WithdrawnCopyBannerProps {
  item: Pick<CatalogItemCopy, "statusCode" | "withdrawnAt" | "withdrawalReason">;
}

export function WithdrawnCopyBanner({ item }: WithdrawnCopyBannerProps) {
  const isWithdrawn = item.statusCode === "WITHDRAWN" || Boolean(item.withdrawnAt);
  if (!isWithdrawn) return null;

  const withdrawnDate = item.withdrawnAt
    ? new Date(item.withdrawnAt).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : null;

  return (
    <div className="flex items-start gap-2 p-3 rounded-lg border border-amber-200 bg-amber-50">
      <Archive className="w-4 h-4 text-amber-600 shrink-0 mt-0.5" />
      <div className="text-sm text-amber-800">
        <p className="font-medium">Withdrawn from circulation</p>
        {withdrawnDate && <p className="text-xs text-amber-700 mt-0.5">Since {withdrawnDate}</p>}
        {item.withdrawalReason && (
          <p className="text-xs text-amber-700 mt-1">
            <span className="font-medium">Reason:</span> {item.withdrawalReason}
          </p>
        )}
      </div>
    </div>
  );
}
